import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { VerificationPackage, VerificationPackageDetail } from '../../../models/VerificationPackage';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { VerificationPackagesService } from '../../../services/verification-packages.service';

@Component({
  selector: 'app-basic-info-dialog',
  templateUrl: './basic-info-dialog.component.html',
  styleUrls: ['./basic-info-dialog.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule, 
    MatIcon,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatDialogModule,
    CommonModule
  ]
})
export class VerificationPackageBasicInfoDialogComponent implements OnInit {

  form!: FormGroup;
  allVerificationPackages: VerificationPackageDetail[] = [];
  verificationPackageNameExists: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<VerificationPackageBasicInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private verificationPackageService: VerificationPackagesService
  ) { }

  ngOnInit() {
    this.initForm();
    this.populateVerificationPackages();

    if (this.data) {
      this.populateForm(this.data);
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      name: ['', {
        validators: [Validators.required, this.checkForDuplicateVerifPackageName()],
        updateOn: 'change'
      }],
      description: ['']
    });
  }

  checkForDuplicateVerifPackageName(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.allVerificationPackages.some(verifPackage => verifPackage.name.toLowerCase() === control.value.toLowerCase())) {
        this.verificationPackageNameExists = true;
      } else {
        this.verificationPackageNameExists = false;
        false;
      }
      return this.verificationPackageNameExists ? { invalidVerificationPackageName: this.verificationPackageNameExists } : null;
    };
  }

  async populateVerificationPackages() {
    this.allVerificationPackages = await this.verificationPackageService.getVerificationPackages();
  }

  populateForm(verificationPackage: VerificationPackage) {
    this.form.patchValue(verificationPackage);
  }

  submitVerificationPackage() {
    let payload = {
      name: this.form.get('name')?.value,
      description: this.form.get('description')?.value
    }
    this.dialogRef.close(payload);
  }

  canCreateVerificationPackage(): boolean {
    return (
      this.form.valid &&
      !this.verificationPackageNameExists
    );
  }
}